function getUserEmployeeOrGuest({activeOrg}) {
  return {
    isEmployee: _.includes(['owner', 'member'], _.get(activeOrg, 'role')) && !_.get(activeOrg, 'prevRole'),
    isGuest: !_.includes(['owner', 'member'], _.get(activeOrg, 'role')),
    isGuestMode: !!(_.get(activeOrg, 'prevRole') && _.get(activeOrg, 'role') === 'guest')
  };
}

export { getUserEmployeeOrGuest };